import TripChatDesktopSurface, { type TripChatDesktopSurfaceProps } from './surfaces/TripChatDesktopSurface'
import TripChatMobileSurface from './surfaces/TripChatMobileSurface'

export type TripChatSurface = 'desktop' | 'mobile'

type TripChatSurfaceRouterProps =
  | { surface: 'desktop'; desktopSurfaceProps: TripChatDesktopSurfaceProps }
  | { surface: 'mobile' }

function TripChatSurfaceRouter(props: TripChatSurfaceRouterProps) {
  if (props.surface === 'mobile') {
    return <TripChatMobileSurface />
  }
  const { desktopSurfaceProps } = props
  return <TripChatDesktopSurface {...desktopSurfaceProps} />
}

export default TripChatSurfaceRouter
